module.exports = "/images/public-health-statement@3x.png?704787c9e3784f48e950998add5ebdb0";